if($('#userVehiclesDatatable').length > 0) {
    url = $('#userVehiclesDatatable').attr('data-url');
    dt = $("#userVehiclesDatatable").DataTable({
        searchDelay: 500,
        order: [[3, 'desc'], [1, 'desc']],
        language: window.datatableLanguage,
        searching: true,
        serverSide: true,
        processing: true,
        responsive: true,
        ajax: url,
        select: {
            style: 'os',
            selector: 'td:first-child',
            className: 'row-selected'
        },
        columns: [
            {data: 'plate'},
            {data: 'label'},
            {data: 'fuel'},
            {data: 'status'},
            {data: 'actions'}
        ],
        columnDefs: [
            {
                targets: 0,
                orderable: true
            },
            {
                targets: 1,
                orderable: true
            },
            {
                targets: 2,
                orderable: true
            },
            {
                targets: 3,
                orderable: true
            },
            {
                targets: 4,
                orderable: false
            }
        ]
    });

    const filterSearch = document.querySelector('[data-kt-table-filter-userVehiclesDatatable="search"]');
    filterSearch.addEventListener('keyup', function (e) {
        dt.search(e.target.value).draw();
    });
}
